import React from 'react'
import styles from "./HotelCard.module.css"
import { useTranslation } from "../../../../contexts/TranslationContext";

const HotelCard = ({ date, travelers, title, location, price, discount, }) => {
    const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.contentHeader}>
            <div className={styles.date}>
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                    <path d="M9.35 1.2H8.25V0.6C8.25 0.44087 8.19205 0.288258 8.08891 0.175736C7.98576 0.0632141 7.84587 0 7.7 0C7.55413 0 7.41424 0.0632141 7.31109 0.175736C7.20795 0.288258 7.15 0.44087 7.15 0.6V1.2H3.85V0.6C3.85 0.44087 3.79205 0.288258 3.68891 0.175736C3.58576 0.0632141 3.44587 0 3.3 0C3.15413 0 3.01424 0.0632141 2.91109 0.175736C2.80795 0.288258 2.75 0.44087 2.75 0.6V1.2H1.65C1.21239 1.2 0.792709 1.38964 0.483274 1.72721C0.173839 2.06477 0 2.52261 0 3V10.2C0 10.6774 0.173839 11.1352 0.483274 11.4728C0.792709 11.8104 1.21239 12 1.65 12H9.35C9.78761 12 10.2073 11.8104 10.5167 11.4728C10.8262 11.1352 11 10.6774 11 10.2V3C11 2.52261 10.8262 2.06477 10.5167 1.72721C10.2073 1.38964 9.78761 1.2 9.35 1.2ZM9.9 10.2C9.9 10.3591 9.84206 10.5117 9.73891 10.6243C9.63577 10.7368 9.49587 10.8 9.35 10.8H1.65C1.50413 10.8 1.36424 10.7368 1.26109 10.6243C1.15795 10.5117 1.1 10.3591 1.1 10.2V6H9.9V10.2ZM9.9 4.8H1.1V3C1.1 2.84087 1.15795 2.68826 1.26109 2.57574C1.36424 2.46321 1.50413 2.4 1.65 2.4H2.75V3C2.75 3.15913 2.80795 3.31174 2.91109 3.42426C3.01424 3.53679 3.15413 3.6 3.3 3.6C3.44587 3.6 3.58576 3.53679 3.68891 3.42426C3.79205 3.31174 3.85 3.15913 3.85 3V2.4H7.15V3C7.15 3.15913 7.20795 3.31174 7.31109 3.42426C7.41424 3.53679 7.55413 3.6 7.7 3.6C7.84587 3.6 7.98576 3.53679 8.08891 3.42426C8.19205 3.31174 8.25 3.15913 8.25 3V2.4H9.35C9.49587 2.4 9.63577 2.46321 9.73891 2.57574C9.84206 2.68826 9.9 2.84087 9.9 3V4.8Z" fill="#696969"/>
                </svg>
                <div>
                    {date}
                </div>
            </div> 
            <div className={styles.travelers}>
                {travelers}
            </div>
        </div>
     
        <div className={styles.name}>{title}</div>
        <div className={styles.location}>{location}</div>
      </div>
      <div className={styles.priceContainer}>
            <div className={styles.price}>
                {price} 
                {/* <span>{discount}</span> */}
            </div>
            <div className={styles.priceLabel}>{t("IncludesTaxes")}</div>
      </div>
    </div>
  )
}

export default HotelCard
